import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'features.walletErDetailPage.pageTitle',
    defaultMessage: 'Dettaglio e approfondimento',
    description: 'Title of wallet er detail page',
  },
  reportVideoTitle: {
    id: 'features.walletErDetailPage.reportVideoTitle',
    defaultMessage: 'Reportistica investimenti in economia reale',
    description: 'Video description title',
  },
  videoTitle: {
    id: 'features.walletErDetailPage.videoTitle',
    defaultMessage: 'Azimut per te',
    description: 'Video title',
  },
  tableHeader: {
    id: 'features.walletErDetailPage.tableHeader',
    defaultMessage: 'Economia reale',
    description: 'Table header',
  },
  tableHeaderAmount: {
    id: 'features.walletErDetailPage.tableHeaderAmount',
    defaultMessage: 'Totale:',
    description: 'Table header amount',
  },
  productDescriptionColumn: {
    id: 'features.walletErDetailPage.productDescriptionColumn',
    defaultMessage: 'Prodotto',
    description: 'Table header Prodotto',
  },
  contractColumn: {
    id: 'features.walletErDetailPage.contractColumn',
    defaultMessage: 'Contratto',
    description: 'Table header Contratto',
  },
  commitmentColumn: {
    id: 'features.walletErDetailPage.commitmentColumn',
    defaultMessage: 'Commitment',
    description: 'Table header Commitment',
  },
  versatoColumn: {
    id: 'features.walletErDetailPage.versatoColumn',
    defaultMessage: 'Versato',
    description: 'Table header Versato',
  },
  counterValueColumn: {
    id: 'features.walletErDetailPage.counterValueColumn',
    defaultMessage: 'Controvalore',
    description: 'Table header Controvalore',
  },
  versatoDisclaimer: {
    id: 'features.walletErDetailPage.versatoDisclaimer',
    defaultMessage:
      '1. Il Versato rappresenta esclusivamente l’ammontare versato dal Cliente',
    description: 'Disclaimer versato',
  },
  residuoInvestibileDisclaimer:{
    id: 'features.walletErDetailPage.residuoInvestibileDisclaimer',
    defaultMessage:
      '3. Il valore considerato rappresenta la percentuale minore fra la concentrazione illiquidi e complessi',
    description: 'Disclaimer Residuo Investibile',
  },
  videoDescription: {
    id: 'features.walletErDetailPage.videoDescription',
    defaultMessage:
      'In contesti in cui gli strumenti finanziari più tradizionali stentano nella generazione di valore, è importante aprire il proprio portafoglio a strategie che sfruttano soluzioni di investimento alternative. Gli strumenti di Economia Reale sono la soluzione che, nel contesto attuale, meglio integrano strategie di diversificazione del portafoglio tese al medio lungo periodo ed alla migliore ottimizzazione dei rendimenti. ' +
      'Investire in strumenti di Economia Reale oggi, non è soltanto una scelta di valore per i nostri portafogli, ma rappresenta anche un’opportunità unica per partecipare in modo indiretto alla crescita del sistema Italia, investendo nelle migliori aziende che lo rappresentano nell’ambito del non quotato',
    description: 'Video description',
  },
  portfolioSummaryTitle: {
    id: 'features.walletErDetailPage.portfolioSummaryTitle',
    defaultMessage: 'Portfolio summary',
    description: 'Title',
  },
  portfolioSummaryLabel: {
    id: 'features.walletErDetailPage.portfolioSummaryLabel',
    defaultMessage: 'Sul tuo intero portafoglio',
    description: 'Summary label',
  },
  portfoglioSummaryTotal: {
    id: 'features.walletErDetailPage.portfoglioSummaryTotal',
    defaultMessage: 'Totale',
    description: 'Totale',
  },
  portfolioAssetClassTitle: {
    id: 'features.walletErDetailPage.portfolioAssetClassTitle',
    defaultMessage: 'Concentrazione per asset class reale',
    description: 'Concentrazione per asset class reale',
  },
  riskProfileSectionTitle: {
    id: 'features.walletErDetailPage.riskProfileSectionTitle',
    defaultMessage: 'Profilo di rischio',
    description: 'risk profile section title',
  },
  riskProfileMarketRiskName: {
    id: 'features.walletErDetailPage.riskProfileMarketRiskName',
    defaultMessage: 'Volatilità di mercato',
    description: 'display name for market risk parameter',
  },
  riskProfileMarketRiskDescription: {
    id: 'features.walletErDetailPage.riskProfileMarketRiskDescription',
    defaultMessage: 'Valore sintetico del rischio di mercato',
    description: 'display description for market risk parameter',
  },
  riskProfileIlliquidityName: {
    id: 'features.walletErDetailPage.riskProfileIlliquidityName',
    defaultMessage: 'Concentrazione illiquidi',
    description: 'display name for illiquidity parameter',
  },
  riskProfileIlliquidityDescription: {
    id: 'features.walletErDetailPage.riskProfileIlliquidityDescription',
    defaultMessage: 'Peso % di prodotti illiquidi sul portafoglio',
    description: 'display description for illiquidity parameter',
  },
  riskProfileComplexName: {
    id: 'features.walletErDetailPage.riskProfileComplexName',
    defaultMessage: 'Concentrazione complessi',
    description: 'display name for complex parameter',
  },
  riskProfileComplexDescription: {
    id: 'features.walletErDetailPage.riskProfileComplexDescription',
    defaultMessage: 'Peso % di prodotti complessi sul portafoglio',
    description: 'display description for complex parameter',
  },
  riskProfileCreditRiskName: {
    id: 'features.walletErDetailPage.riskProfileCreditRiskName',
    defaultMessage: 'Concentrazione rischio di credito',
    description: 'display name for creditRisk parameter',
  },
  riskProfileCreditRiskDescription: {
    id: 'features.walletErDetailPage.riskProfileCreditRiskDescription',
    defaultMessage:
      'Peso % di prodotti con elevati rischio di credito sul portafoglio',
    description: 'display description for creditRisk parameter',
  },
  riskProfileInvestableResidualName: {
    id: 'features.walletErDetailPage.riskProfileInvestableResidualName',
    defaultMessage:
      'Residuo investibile in Economia Reale - Fondi di investimento alternativi',
    description: 'display name for investableResidual parameter',
  },
  riskProfileInvestableResidualDescription: {
    id: 'features.walletErDetailPage.riskProfileInvestableResidualDescription',
    defaultMessage:
      'Peso % ulteriori investimenti disponibili in economia reale',
    description: 'display description for investableResidual parameter',
  },
  riskProfileEsgName: {
    id: 'features.walletErDetailPage.riskProfileEsgName',
    defaultMessage: 'Concentrazione ESG',
    description: 'display name for esg parameter',
  },
  riskProfileEsgDescription: {
    id: 'features.walletErDetailPage.riskProfileEsgDescription',
    defaultMessage: 'Peso % di prodotti ESG sul portafoglio',
    description: 'display description for esg parameter',
  },
  riskProfileParameterNameColumn: {
    id: 'features.walletErDetailPage.riskProfileParameterNameColumn',
    defaultMessage: 'Parametro',
    description: 'table header parameter name',
  },
  riskProfileParameterDescriptionColumn: {
    id: 'features.walletErDetailPage.riskProfileParameterDescriptionColumn',
    defaultMessage: 'Descrizione parametro',
    description: 'table header parameter description',
  },
  riskProfileValueColumn: {
    id: 'features.walletErDetailPage.riskProfileParameterValueColumn',
    defaultMessage: 'Il suo valore a portafoglio',
    description: 'table header parameter value',
  },
  riskProfileThresholdColumn: {
    id: 'features.walletErDetailPage.riskProfileThresholdColumn',
    defaultMessage: 'Limite Max',
    description: 'table header parameter threshold',
  },
  riskProfileResultColumn: {
    id: 'features.walletErDetailPage.riskProfileResultColumn',
    defaultMessage: 'Esito',
    description: 'table header check result',
  },
  investableResidueWeightLabel: {
    id: 'features.walletErDetailPage.investableResidueWeightLabel',
    defaultMessage: 'Peso residuo investibile in economia reale',
    description: 'investable residue weight label',
  },
  productConcentrationTitle: {
    id: 'features.walletErDetailPage.productConcentrationTitle',
    defaultMessage: 'Concentrazione per prodotti',
    description: 'Title of concentrazione per prodotti pie chart',
  },
  productExpirationDateTitle: {
    id: 'features.walletErDetailPage.productExpirationDateTitle',
    defaultMessage: 'Durata residua del fondo/Periodo di investimento',
    description:
      'Title of Durata residua del fondo/Periodo di investimento section',
  },
  productYears: {
    id: 'features.walletErDetailPage.productYears',
    defaultMessage: 'Anni',
    description: 'Anni',
  },
  productND: {
    id: 'features.walletErDetailPage.productND',
    defaultMessage: 'ND',
    description: 'ND',
  },
  productLabel: {
    id: 'features.walletErDetailPage.productLabel',
    defaultMessage: 'Prodotti',
    description: 'Prodotti',
  },
  videoDescriptionRealEconomy: {
    id: 'features.walletErDetailPage.videoDescriptionRealEconomy',
    defaultMessage:
      'IL MONDO DELL’ECONOMIA REALE: In contesti in cui gli strumenti finanziari più tradizionali stentano nella generazione di valore, è importante aprire il proprio portafoglio.',
    description: 'real economy video description',
  },
  downloadPDF: {
    id: 'features.walletErDetailPage.downloadPDF',
    defaultMessage: 'SCARICA PDF',
    description: 'text for download pdf',
  },
  residualDurationChartEmpty: {
    id: 'features.walletErDetailPage.residualDurationChartEmpty',
    defaultMessage: 'Nessuna informazione da visualizzare',
    description: 'text for residual duration chart when it is empty',
  },
  controvaloreDisclaimer: {
    id: 'features.walletErDetailPage.controvaloreDisclaimer',
    defaultMessage:
      '2. Il controvalore rappresenta il valore effettivo dell’investimento in Economia Reale - Fondi di investimento alternativi',
    description: 'controvaloreDisclaimer versato',
  },
});
